import React, { FC } from 'react';
import { DoubleCtaCardFragment } from '../../../../types/graphqlTypes';
import { DoubleCTACard } from '../../../DoubleCTACard';

export const DoubleCtaCard: FC<DoubleCtaCardFragment> = (props) => (
  <DoubleCTACard {...props} shadow headingComponent="h2" />
);
